<template>
  <v-tooltip bottom :disabled="!tooltip">
    <template v-slot:activator="{ on }">
      <div v-on="on" class="table-amount text-right">
        <div>{{ primary.code }} {{ primary.amount }}</div>
        <div v-if="secondary" class="table-text-secondary">{{ secondary.code }} {{ secondary.amount }}</div>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";

//Muestra el importe en la moneda del comprobante con el equivalente en pesos (o en USD si la fila es ARS)
export default {
  name: "ImporteMoneda",
  props: {
    item: { type: Object, required: true },
    //true cuando imp_total esta en pesos aunque la moneda sea extranjera (Spent)
    amountInPesos: { type: Boolean, default: false },
  },
  computed: {
    totalArs() {
      return this.toNumber(this.item.total_ars);
    },
    totalUsd() {
      return this.toNumber(this.item.total_usd);
    },
    monCotiz() {
      return this.toNumber(this.item.mon_cotiz);
    },
    dolarCotiz() {
      return this.toNumber(this.item.dolar_cotiz);
    },
    //Misma regla que los getters del backend: sin cotizacion de dolar valida el USD es un fallback falso
    validUsdEquivalent() {
      return this.totalUsd !== null && this.totalUsd !== 0 && this.dolarCotiz !== null && this.dolarCotiz > 1;
    },
    //mon_id segun CurrencyConstants: PES = ARS, USD, EUR. Cualquier otro codigo se rotula con su propio codigo.
    isArs() {
      return !this.item.mon_id || this.item.mon_id === "PES";
    },
    isOther() {
      return !this.isArs && this.item.mon_id !== "USD" && this.item.mon_id !== "EUR";
    },
    primary() {
      if (this.isArs) return this.line("ARS", this.totalArs);
      if (this.item.mon_id === "USD") return this.line("USD", this.totalUsd);
      //EUR y monedas desconocidas: imp_total esta en la moneda del comprobante (en pesos con amountInPesos)
      const code = this.item.mon_id;
      if (this.amountInPesos) {
        if (this.monCotiz) return this.line(code, this.totalArs / this.monCotiz);
        return this.isOther ? this.line("ARS", this.totalArs) : this.line(code, null);
      }
      return this.line(code, this.toNumber(this.item.imp_total));
    },
    secondary() {
      //En filas ARS el equivalente en USD va solo en el tooltip
      if (this.isArs || this.isOther) return null;
      if (this.item.mon_id === "USD" || this.amountInPesos) return this.optionalLine("ARS", this.totalArs);
      return this.optionalLine("ARS", this.monCotiz ? this.toNumber(this.item.imp_total) * this.monCotiz : null);
    },
    tooltip() {
      if (this.isOther) return "";
      if (!this.isArs) {
        return this.monCotiz !== null && this.monCotiz > 0 ? "Cotización: " + this.formatRate(this.monCotiz) : "";
      }
      if (this.validUsdEquivalent) {
        return "Equivalente: USD " + formatUtils.formatNumber(Math.abs(this.totalUsd)) + " · Cotización: " + this.formatRate(this.dolarCotiz);
      }
      return "";
    },
  },
  methods: {
    toNumber(value) {
      if (value === null || value === undefined || value === "") return null;
      const n = Number(value);
      return isNaN(n) ? null : n;
    },
    //La cotizacion conserva sus decimales reales (minimo 2)
    formatRate(value) {
      return new Intl.NumberFormat("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 6 }).format(value);
    },
    format(value) {
      //Sin signo: el valor absoluto evita negativos en notas de credito
      return value === null ? "-" : formatUtils.formatNumber(Math.abs(value));
    },
    line(code, value) {
      return { code: code, amount: this.format(value) };
    },
    //La linea secundaria se oculta si el valor es null o 0
    optionalLine(code, value) {
      return value === null || value === 0 || isNaN(value) ? null : this.line(code, value);
    },
  },
};
</script>
